<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">

          <el-form-item label="交易时间">
            <template slot="label">
              <I18Lang id="userstatement93" defaultText="交易时间" />
            </template>
            <el-date-picker style="width:200px" v-model="queryDate" type="daterange" @change="dateChange"
              value-format="yyyy-MM-dd" range-separator="-" :start-placeholder="$t('public22')"
              :end-placeholder="$t('public23')"></el-date-picker>
          </el-form-item>

          <el-form-item label="开平仓">
            <template slot="label">
              <I18Lang id="userstatement94" defaultText="开平仓" />
            </template>
            <el-select style="width:100px" v-model="queryForm.kp" :placeholder="$t('public17')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option v-for="(item, key) in kpObjs" :label="item" :value="key" :key="key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="买/卖">
            <template slot="label">
              <I18Lang id="userstatement97" defaultText="买/卖" />
            </template>
            <el-select style="width:100px" v-model="queryForm.dc" :placeholder="$t('public17')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option v-for="(item, key) in dcObjs" :label="item" :value="key" :key="key"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="交易产品">
            <template slot="label">
              <I18Lang id="userstatement101" defaultText="交易产品" />
            </template>
            <el-input :placeholder="$t('userstatement101')" v-model="queryForm.inst_name"></el-input>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div class="btn kg-refresh btn-query-refresh" @click="resetQuery"></div>

        </el-form>
        <div>
          <div class="btn kg-btn2" @click="importData">
            <I18Lang id="my137" defaultText="导出" />
          </div>
        </div>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column width="200" label="交易单号">
            <template slot="header">
              <I18Lang id="userstatement106" defaultText="交易单号" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.display_order_no || scope.row.order_id || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="交易产品" prop="inst_id">
            <template slot="header">
              <I18Lang id="userstatement101" defaultText="交易产品" />
            </template>
          </el-table-column>
          <el-table-column label="交易价格" prop="price">
            <template slot="header">
              <I18Lang id="userstatement108" defaultText="交易价格" />
            </template>
          </el-table-column>
          <el-table-column label="开平仓">
            <template slot="header">
              <I18Lang id="userstatement109" defaultText="开平仓" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.kp == 0 ? $t('userstatement95') : $t('userstatement96') }}
            </template>
          </el-table-column>
          <el-table-column label="买/卖">
            <template slot="header">
              <I18Lang id="userstatement110" defaultText="买/卖" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.dc == 0 ? $t('userstatement98') : $t('userstatement99') }}
            </template>
          </el-table-column>
          <el-table-column label="交易量" prop="vol">
            <template slot="header">
              <I18Lang id="userstatement111" defaultText="交易量" />
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('userstatement138', { n: currMarket })}`" prop="fee">
          </el-table-column>
          <el-table-column label="Profit and Loss" prop="profit">
          </el-table-column>
          <el-table-column label="交易时间" prop="deal_time">
            <template slot="header">
              <I18Lang id="userstatement114" defaultText="交易时间" />
            </template>
          </el-table-column>
          <el-table-column label="净盈亏" prop="net">
            <template slot="header">
              <I18Lang id="usermoney64" defaultText="净盈亏" />
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { fileDomain, formateObjToParamStr } from '@utils'
import cookie from '@utils/cookie'
import { mapState } from 'vuex'
import { auditStatusList } from '@utils/global'

export default {
  name: 'record',
  data () {
    return {
      fileDomain,
      kpObjs: {
        0: this.$t('userstatement95'), // '开仓',
        1: this.$t('userstatement96') // '平仓'
      },
      dcObjs: {
        0: this.$t('userstatement98'), // '买',
        1: this.$t('userstatement99') // '卖'
      },
      queryDate: '',
      queryForm: {
        model: 1,
        kp: '',
        dc: '',
        inst_name: '',
        start_time: '',
        end_time: '',
        page: 1,
        size: 10
      },
      statusList: auditStatusList,
      tableData: {
        list: [],
        total: 0
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'currMarket'])
  },
  created () {
    this.getRecord()
  },
  methods: {
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/trade/list?${formateObjToParamStr(
          params
        )}`
      )
    },
    getRecord () {
      this.$http
        .post('/api/trade/list', this.queryForm)
        .then((result) => {
          this.tableData = result
        })
    },
    queryQuery () {
      this.pageChange(1)
    },
    resetQuery () {
      Object.keys(this.queryForm).map(item => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryDate.model = '1'
      this.queryDate = ''
      this.pageChange(1)
    },
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss"></style>
